/* benrennie.com — theme JS
 * Lean. Vanilla. No framework.
 * Owns: drawer system, product option swap, gallery, qty stepper,
 *       cart fetch + add-to-cart, sticky mini-cart, book flip.
 */
(function () {
  "use strict";

  window.__benrennieTheme = { v: "0.3.0" };

  // ===================================================================
  // NAV HEIGHT — measure the fixed nav and expose as --nav-h
  // (Robust against announce bar toggling, font load shifts, resize.)
  // ===================================================================
  (function () {
    var nav = document.querySelector(".nav");
    if (!nav) return;
    function setH() {
      var h = nav.offsetHeight;
      if (h > 0) document.documentElement.style.setProperty("--nav-h", h + "px");
    }
    setH();
    if ("ResizeObserver" in window) {
      new ResizeObserver(setH).observe(nav);
    }
    window.addEventListener("resize", setH);
    window.addEventListener("load", setH);
  })();

  var moneyFormat = (window.Shopify && Shopify.currency && Shopify.currency.active) || "AUD";
  function money(cents) {
    var n = (cents / 100).toFixed(2);
    return "A$ " + n;
  }

  // ===================================================================
  // DRAWER SYSTEM
  // ===================================================================
  var scrim = document.querySelector("[data-scrim]");
  var drawers = Array.from(document.querySelectorAll("[data-drawer]"));
  var openDrawer = null;
  var syncDetailsDrawer = function () {}; // overwritten when product zone initialises

  function setOpenDrawer(name) {
    drawers.forEach(function (d) {
      var isOpen = d.dataset.drawer === name;
      d.classList.toggle("is-open", isOpen);
      d.setAttribute("aria-hidden", isOpen ? "false" : "true");
    });
    if (scrim) scrim.classList.toggle("is-open", !!name);
    document.body.classList.toggle("is-locked", !!name);
    openDrawer = name;
    // hide sticky cart when cart drawer is open
    var sticky = document.querySelector("[data-sticky-cart]");
    if (sticky && name === "cart") sticky.classList.remove("is-visible");

    // Lazy-load cart contents on open
    if (name === "cart") refreshCart();
  }
  function closeDrawer() { setOpenDrawer(null); }

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-drawer-open]");
    if (opener) {
      e.preventDefault();
      var which = opener.getAttribute("data-drawer-open");
      if (which === "details") syncDetailsDrawer();
      setOpenDrawer(which);
      // Auto-flip the book when opening from the product gallery
      if (which === "book") {
        var bookEl = document.querySelector("[data-book]");
        if (bookEl) setTimeout(function () { bookEl.classList.add("is-open"); syncBookHint(); }, 240);
      }
      return;
    }

    var selector = e.target.closest("[data-cta-select]");
    if (selector) {
      e.preventDefault();
      var which2 = selector.getAttribute("data-cta-select");
      if (window.__benSetOption) window.__benSetOption(which2);
      var panel = document.getElementById("purchase-panel-aside");
      if (panel) panel.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (e.target.closest("[data-drawer-close]") || e.target === scrim) {
      closeDrawer();
    }
  });

  function syncBookHint() {
    var book  = document.querySelector("[data-book]");
    var label = document.querySelector("[data-book-toggle-label]");
    var hint  = document.querySelector("[data-book-hint]");
    if (!book) return;
    var open = book.classList.contains("is-open");
    if (label) label.textContent = open ? "Close book" : "Open book";
    if (hint)  hint.textContent  = open ? "Tap the book to close" : "Tap the book to open";
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && openDrawer) closeDrawer();
  });

  // ===================================================================
  // PRODUCT ZONE — option swap, gallery, qty, add-to-cart
  // ===================================================================
  var zone = document.querySelector("[data-product-zone]");

  if (zone) {
    var bookId    = zone.dataset.bookId;
    var systemId  = zone.dataset.systemId;
    var bookPrice = zone.dataset.bookPrice;
    var systemPrice = zone.dataset.systemPrice;

    var galleryDataEl = document.querySelector("[data-gallery-data]");
    var galleryData = { book: [], system: [] };
    try { galleryData = JSON.parse(galleryDataEl.textContent); } catch (_) {}

    var mainImg     = document.querySelector("[data-gallery-main-img]");
    var counterEl   = document.querySelector("[data-gallery-counter]");
    var tagEl       = document.querySelector("[data-gallery-tag]");
    var thumbsEl    = document.querySelector("[data-gallery-thumbs]");
    var variantInp  = zone.querySelector("[data-variant-id]");
    var addPriceEl  = zone.querySelector("[data-add-price]");
    var detailsPriceEl = document.querySelector("[data-details-price]");
    var detailsTitleEl = document.querySelector("[data-details-title]");
    var detailsLedeEl  = document.querySelector("[data-details-lede]");
    var detailsEyebrowEl = document.querySelector("[data-details-eyebrow]");
    var stickyName  = document.querySelector("[data-sticky-name]");
    var stickyMeta  = document.querySelector("[data-sticky-meta]");
    var stickyStrike = document.querySelector("[data-sticky-strike]");
    var stickyRowStrike = document.querySelector("[data-sticky-row-strike]");
    var stickyThumb = document.querySelector("[data-sticky-thumb]");
    var stickyPriceEl = document.querySelector("[data-sticky-price]");

    // System thumb starts as the sticky's initial src; book thumb is the first book gallery image.
    var stickyImgs = {
      system: stickyThumb ? stickyThumb.getAttribute("src") : "",
      book:   (galleryData.book[0] && galleryData.book[0].src) || ""
    };

    var galleryIndex = 0;
    var currentOpt = "system";

    function renderGallery() {
      var imgs = galleryData[currentOpt] || [];
      if (!imgs.length) return;
      if (galleryIndex >= imgs.length) galleryIndex = 0;
      if (mainImg) {
        mainImg.setAttribute("src", imgs[galleryIndex].src);
        mainImg.setAttribute("alt", imgs[galleryIndex].alt || "");
      }
      if (counterEl) counterEl.textContent = pad(galleryIndex + 1) + " / " + pad(imgs.length);
      if (tagEl) tagEl.textContent = currentOpt === "system" ? "The System" : "Signed Book";

      if (thumbsEl) {
        thumbsEl.innerHTML = "";
        imgs.forEach(function (img, idx) {
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "gallery-thumb" + (idx === galleryIndex ? " is-active" : "");
          btn.setAttribute("aria-label", "View image " + (idx + 1));
          var im = document.createElement("img");
          im.setAttribute("src", img.src);
          im.setAttribute("alt", "");
          btn.appendChild(im);
          btn.addEventListener("click", function () {
            galleryIndex = idx;
            renderGallery();
          });
          thumbsEl.appendChild(btn);
        });
      }
    }
    function pad(n) { return String(n).padStart(2, "0"); }

    function setOption(opt) {
      currentOpt = opt;
      galleryIndex = 0;
      // Active class
      zone.querySelectorAll(".opt").forEach(function (o) {
        var on = o.dataset.opt === opt;
        o.classList.toggle("is-active", on);
        var radio = o.querySelector('input[type="radio"]');
        if (radio) radio.checked = on;
      });
      // Variant + price
      if (variantInp) variantInp.value = opt === "system" ? systemId : bookId;
      if (addPriceEl) addPriceEl.textContent = opt === "system" ? systemPrice : bookPrice;
      if (detailsPriceEl) detailsPriceEl.textContent = opt === "system" ? systemPrice : bookPrice;
      // Sticky toggle + sticky data
      document.querySelectorAll("[data-sticky-opt]").forEach(function (b) {
        var on = b.getAttribute("data-sticky-opt") === opt;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      if (stickyName)  stickyName.textContent  = opt === "system" ? "The System" : "The Signed Book";
      if (stickyMeta)  stickyMeta.textContent  = opt === "system" ? "10 items · 12 workshops" : "Signed · Manifesto Bookmark";
      if (stickyThumb) stickyThumb.setAttribute("src", stickyImgs[opt] || stickyImgs.system);
      if (stickyPriceEl) stickyPriceEl.textContent = opt === "system" ? systemPrice : bookPrice;
      if (stickyStrike) stickyStrike.style.display = opt === "system" ? "" : "none";
      if (stickyRowStrike) stickyRowStrike.style.display = opt === "system" ? "" : "none";

      // Details drawer
      syncDetailsDrawer();

      renderGallery();
    }

    syncDetailsDrawer = function () {
      if (!detailsTitleEl) return;
      var isSystem = currentOpt === "system";
      detailsTitleEl.textContent = isSystem ? "The System" : "The Book";
      if (detailsEyebrowEl) detailsEyebrowEl.textContent = isSystem ? "The System · Full details" : "The Book · Full details";
      if (detailsLedeEl) {
        var ledeSystem = detailsLedeEl.getAttribute("data-lede-system");
        var ledeBook   = detailsLedeEl.getAttribute("data-lede-book");
        if (ledeSystem || ledeBook) {
          detailsLedeEl.textContent = isSystem ? (ledeSystem || detailsLedeEl.textContent) : (ledeBook || detailsLedeEl.textContent);
        }
      }
    };

    // Wire option click
    zone.querySelectorAll(".opt").forEach(function (o) {
      o.addEventListener("click", function (e) {
        e.preventDefault();
        setOption(o.dataset.opt);
      });
    });

    // Wire sticky cart toggle
    document.querySelectorAll("[data-sticky-opt]").forEach(function (b) {
      b.addEventListener("click", function () { setOption(b.getAttribute("data-sticky-opt")); });
    });

    // Qty stepper
    var qtyInput = zone.querySelector("#qty");
    var qtyDec = zone.querySelector("[data-qty-dec]");
    var qtyInc = zone.querySelector("[data-qty-inc]");
    function setQty(n) {
      n = Math.max(1, parseInt(n, 10) || 1);
      if (qtyInput) qtyInput.value = n;
    }
    if (qtyDec) qtyDec.addEventListener("click", function () { setQty((parseInt(qtyInput.value, 10) || 1) - 1); });
    if (qtyInc) qtyInc.addEventListener("click", function () { setQty((parseInt(qtyInput.value, 10) || 1) + 1); });

    // Add to cart — form submit
    var form = zone.querySelector("[data-purchase-panel]");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        addToCart(fd);
      });
    }

    // "Add The System to bag" from kit drawer / "Add to bag" from details drawer
    document.querySelectorAll("[data-add-system]").forEach(function (b) {
      b.addEventListener("click", function () {
        setOption("system");
        var fd = new FormData(form);
        fd.set("id", systemId);
        fd.set("quantity", "1");
        addToCart(fd);
      });
    });
    // "Add signed book to bag" — header book CTA.
    // Build a fresh FormData (no System form props that the book variant may reject).
    document.querySelectorAll("[data-add-book]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (!bookId) {
          console.warn("[nav-buy] book variant id missing — check book_handle in product zone settings");
          alert("This product isn't set up yet. Try the System bundle.");
          return;
        }
        setOption("book");
        var fd = new FormData();
        fd.set("id", bookId);
        fd.set("quantity", "1");
        addToCart(fd);
      });
    });
    document.querySelectorAll("[data-add-current]").forEach(function (b) {
      b.addEventListener("click", function () {
        var fd = new FormData(form);
        addToCart(fd);
      });
    });

    // Expose so three-ways CTA can drive it
    window.__benSetOption = setOption;

    // Initial render
    setOption("system");
  }

  function addToCart(formData) {
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root || "/") + "cart/add.js";
    fetch(url, {
      method: "POST",
      headers: { "Accept": "application/javascript" },
      body: formData,
      credentials: "same-origin"
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          alert(res.data && res.data.description || "Could not add item to bag.");
          return;
        }
        // Stash last-added for the cart drawer success ribbon
        window.__benLastAdded = {
          title: (res.data.product_title || res.data.title || "Item"),
          variant: res.data.variant_title || null
        };
        setOpenDrawer("cart");
      })
      .catch(function (err) {
        console.error("Add to cart failed", err);
        alert("Could not add item to bag.");
      });
  }

  // ===================================================================
  // CART DRAWER — fetch /cart.js and render
  // ===================================================================
  function refreshCart() {
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root || "/") + "cart.js";
    fetch(url, { headers: { "Accept": "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function (err) { console.error("Cart fetch failed", err); });
  }

  function renderCart(cart) {
    var bodyEl  = document.querySelector("[data-cart-body]");
    var footEl  = document.querySelector("[data-cart-foot]");
    var totalEl = document.querySelector("[data-cart-total]");
    var eyebrow = document.querySelector("[data-cart-eyebrow]");
    var bag = document.querySelector(".nav-bag-count");
    var bagMeta = document.querySelector(".nav-bag-meta");
    if (bag) bag.textContent = cart.item_count;
    if (bagMeta) bagMeta.textContent = cart.item_count === 0 ? "Empty" : (cart.item_count + " item" + (cart.item_count === 1 ? "" : "s"));

    if (!bodyEl) return;
    bodyEl.innerHTML = "";

    if (window.__benLastAdded && cart.items.length) {
      eyebrow && (eyebrow.textContent = "Added to your bag");
      var s = document.createElement("div");
      s.className = "cart-success";
      s.innerHTML = '<span class="cart-success-tick" aria-hidden="true">✓</span><span><b>' +
        escapeHtml(window.__benLastAdded.title) + "</b> · added to your bag</span>";
      bodyEl.appendChild(s);
      window.__benLastAdded = null;
    } else if (eyebrow) {
      eyebrow.textContent = "Your bag";
    }

    if (cart.items.length === 0) {
      var empty = document.createElement("div");
      empty.className = "cart-empty";
      empty.innerHTML = '<h2 class="kit-title" style="font-size:36px">Your bag is empty.</h2>' +
        '<p class="kit-lede" style="margin-top:16px">Pick the Signed Book or The System on the right rail. You can swap between them up until you hit checkout.</p>';
      bodyEl.appendChild(empty);
      if (footEl) footEl.hidden = true;
      return;
    }

    cart.items.forEach(function (line) {
      var lineEl = document.createElement("div");
      lineEl.className = "cart-line";
      lineEl.innerHTML = [
        '<div class="cart-line-img"><img src="', line.image || "", '" alt=""></div>',
        '<div>',
          '<div class="cart-line-name">', escapeHtml(line.product_title), '</div>',
          '<div class="cart-line-meta">', escapeHtml(line.variant_title || ""), '</div>',
          '<div class="cart-line-controls">',
            '<span class="qty">',
              '<button type="button" aria-label="Decrease" data-line-dec="', line.key, '">−</button>',
              '<span>', line.quantity, '</span>',
              '<button type="button" aria-label="Increase" data-line-inc="', line.key, '">+</button>',
            '</span>',
            '<button type="button" class="remove" data-line-remove="', line.key, '">Remove</button>',
          '</div>',
        '</div>',
        '<div class="cart-line-price">',
          money(line.final_line_price),
          line.original_line_price > line.final_line_price ? '<div class="cart-line-strike">' + money(line.original_line_price) + '</div>' : '',
        '</div>'
      ].join("");
      bodyEl.appendChild(lineEl);
    });

    var totals = document.createElement("div");
    totals.className = "cart-totals";
    totals.innerHTML =
      '<div class="cart-total-row"><span>Subtotal</span><span>' + money(cart.items_subtotal_price) + '</span></div>' +
      '<div class="cart-total-row"><span>Shipping</span><span>Free · Sydney</span></div>' +
      '<div class="cart-total-row"><span>Tax</span><span>Calculated at checkout</span></div>' +
      '<div class="cart-total-row is-bold"><b>Total</b><b>' + money(cart.total_price) + '</b></div>';
    bodyEl.appendChild(totals);

    var note = document.createElement("div");
    note.style.cssText = "border-top:1px solid var(--rule);padding-top:16px;margin-top:16px;font-family:var(--font-mono);font-size:11px;color:var(--fg-muted);letter-spacing:0.06em;line-height:1.6";
    note.textContent = "Every copy signed by hand. Shipped from Sydney within 48 hours. Carbon offset on every order.";
    bodyEl.appendChild(note);

    if (footEl) {
      footEl.hidden = false;
      if (totalEl) totalEl.textContent = money(cart.total_price);
    }
  }

  document.addEventListener("click", function (e) {
    var rem = e.target.closest("[data-line-remove]");
    var inc = e.target.closest("[data-line-inc]");
    var dec = e.target.closest("[data-line-dec]");
    if (!(rem || inc || dec)) return;
    var key = (rem || inc || dec).getAttribute("data-line-remove") || (rem || inc || dec).getAttribute("data-line-inc") || (rem || inc || dec).getAttribute("data-line-dec");
    e.preventDefault();
    if (rem) changeCartLine(key, 0);
    if (inc) bumpCartLine(key, +1);
    if (dec) bumpCartLine(key, -1);
  });

  function bumpCartLine(key, delta) {
    var qtyEl = document.querySelector('[data-line-inc="' + key + '"], [data-line-dec="' + key + '"]');
    if (!qtyEl) return;
    var span = qtyEl.parentElement.querySelector("span");
    var current = parseInt((span && span.textContent) || "1", 10) || 1;
    changeCartLine(key, Math.max(0, current + delta));
  }
  function changeCartLine(key, quantity) {
    var url = (window.Shopify && Shopify.routes && Shopify.routes.root || "/") + "cart/change.js";
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  // ===================================================================
  // STICKY MINI-CART
  // ===================================================================
  (function () {
    var sticky = document.querySelector("[data-sticky-cart]");
    var panel  = document.getElementById("purchase-panel-aside");
    if (!sticky || !panel) return;
    var dismissed = false;
    var raf = 0;
    function update() {
      raf = 0;
      if (dismissed || openDrawer === "cart") {
        sticky.classList.remove("is-visible");
        return;
      }
      var rect = panel.getBoundingClientRect();
      sticky.classList.toggle("is-visible", rect.bottom < 0);
    }
    window.addEventListener("scroll", function () {
      if (raf) return;
      raf = requestAnimationFrame(update);
    }, { passive: true });
    update();
    var dismiss = sticky.querySelector("[data-sticky-dismiss]");
    if (dismiss) dismiss.addEventListener("click", function () {
      dismissed = true;
      sticky.classList.remove("is-visible");
    });
  })();

  // ===================================================================
  // BOOK FLIP
  // ===================================================================
  (function () {
    var book = document.querySelector("[data-book]");
    var toggle = document.querySelector("[data-book-toggle]");
    if (!book) return;
    function flip() {
      book.classList.toggle("is-open");
      syncBookHint();
    }
    book.addEventListener("click", flip);
    book.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); flip(); } });
    if (toggle) toggle.addEventListener("click", flip);
    // Reset to closed when drawer closes
    var drawer = document.querySelector('[data-drawer="book"]');
    if (drawer) {
      var observer = new MutationObserver(function () {
        if (!drawer.classList.contains("is-open")) {
          book.classList.remove("is-open");
          syncBookHint();
        }
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ["class"] });
    }
  })();

  // ===================================================================
  // ENDORSEMENT CAROUSEL
  // ===================================================================
  (function () {
    var stage = document.querySelector("[data-endorsement-carousel]");
    if (!stage) return;
    var slides = Array.from(stage.querySelectorAll("[data-endorse-slide]"));
    var dots   = Array.from(stage.querySelectorAll("[data-endorse-dot]"));
    var prev   = stage.querySelector("[data-endorse-prev]");
    var next   = stage.querySelector("[data-endorse-next]");
    if (slides.length < 2) return;
    var idx = 0;
    var timer = 0;
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (el, n) { el.classList.toggle("is-active", n === idx); });
      dots.forEach(function (el, n)   { el.classList.toggle("is-active", n === idx); });
    }
    function reset() { clearInterval(timer); timer = setInterval(function () { show(idx + 1); }, 7000); }
    if (prev) prev.addEventListener("click", function () { show(idx - 1); reset(); });
    if (next) next.addEventListener("click", function () { show(idx + 1); reset(); });
    dots.forEach(function (d, n) {
      d.addEventListener("click", function () { show(n); reset(); });
    });
    show(0); reset();
  })();

  // ===================================================================
  // LENIS — smooth scrolling
  // ===================================================================
  (function () {
    if (!window.Lenis) {
      // Lenis loaded via defer; try again after window load
      window.addEventListener("load", initLenis, { once: true });
      return;
    }
    initLenis();
    function initLenis() {
      if (!window.Lenis) return;
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      var lenis = new window.Lenis({ lerp: 0.08, smoothWheel: true });
      function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
      window.__benLenis = lenis;
      // Hook smooth anchor links into Lenis (overrides our previous scrollIntoView)
      document.addEventListener("click", function (e) {
        var link = e.target.closest('a[href^="#"]:not([href="#"])');
        if (!link) return;
        var id = link.getAttribute("href").slice(1);
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        lenis.scrollTo(target, { offset: -120 });
      });
    }
  })();

  // ===================================================================
  // SCROLL REVEAL — opacity + translateY on viewport enter
  // ===================================================================
  (function () {
    var els = document.querySelectorAll("[data-reveal]");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-revealed"); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed");
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.05 });
    els.forEach(function (el) { obs.observe(el); });
  })();

  // ===================================================================
  // COUNT-UP — animate numeric values from 0 → target on viewport enter
  // ===================================================================
  (function () {
    var nums = document.querySelectorAll("[data-count-up]");
    if (!nums.length || !("IntersectionObserver" in window)) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      nums.forEach(function (el) {
        el.textContent = el.getAttribute("data-count-up");
      });
      return;
    }
    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
    function countUp(el) {
      var raw = el.getAttribute("data-count-up");
      var hasDecimal = raw.indexOf(".") !== -1;
      var target = parseFloat(raw);
      if (isNaN(target)) return;
      var dur = 1600;
      var start = 0;
      function frame(now) {
        if (!start) start = now;
        var t = Math.min((now - start) / dur, 1);
        var val = target * easeOut(t);
        el.textContent = hasDecimal ? val.toFixed(2) : Math.round(val);
        if (t < 1) requestAnimationFrame(frame);
        else el.textContent = raw;
      }
      requestAnimationFrame(frame);
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          countUp(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    nums.forEach(function (el) {
      el.textContent = "0";
      obs.observe(el);
    });
  })();

  // ===================================================================
  // PARALLAX — scroll-driven translateY for opted-in elements
  // ===================================================================
  (function () {
    var els = document.querySelectorAll("[data-parallax]");
    if (!els.length) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var raf = 0;
    function update() {
      raf = 0;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        // Only compute if in/near viewport
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var speed = parseFloat(el.getAttribute("data-parallax")) || 0.2;
        // distance of element center from viewport center
        var dist = (rect.top + rect.height / 2) - vh / 2;
        var offset = dist * speed * -1;
        el.style.transform = "translate3d(0, " + offset.toFixed(1) + "px, 0)";
      });
    }
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(update);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  })();

  // ===================================================================
  // LENIS-PREVENT GUARD — strip data-lenis-prevent on touch devices,
  // because on mobile the right-rail panel is static (no internal scroll)
  // and Lenis-prevent there blocks page scroll on any touch over it.
  // ===================================================================
  (function () {
    var mq = window.matchMedia("(max-width: 1100px)");
    var els = Array.from(document.querySelectorAll(".product-right[data-lenis-prevent]"));
    if (!els.length) return;
    function apply() {
      els.forEach(function (el) {
        if (mq.matches) {
          if (el.hasAttribute("data-lenis-prevent")) {
            el.dataset.__lenisPreventCache = "1";
            el.removeAttribute("data-lenis-prevent");
          }
        } else if (el.dataset.__lenisPreventCache === "1") {
          el.setAttribute("data-lenis-prevent", "");
        }
      });
    }
    apply();
    if (mq.addEventListener) mq.addEventListener("change", apply);
    else if (mq.addListener) mq.addListener(apply);
  })();

  // ===================================================================
  // HEADER SCROLL STATE — swap nav cells for buy CTA after hero
  // + directional announce hide (hide on scroll down, show on scroll up)
  // Triple trigger for reliability: IntersectionObserver + scroll listener
  // + Lenis on('scroll'). Whichever fires first wins.
  // ===================================================================
  (function () {
    var nav = document.querySelector(".nav");
    var hero = document.querySelector(".hero");
    if (!nav || !hero) return;

    var threshold = 120; // px of hero remaining before swap fires
    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var dirDelta = 0; // accumulated scroll delta — only flip after 8px sustained

    function isPastHero() {
      var rect = hero.getBoundingClientRect();
      return rect.bottom < threshold;
    }
    function update() {
      nav.classList.toggle("is-scrolled", isPastHero());

      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var dy = y - lastY;
      lastY = y;

      // At the very top → always show announce
      if (y < 40) {
        nav.classList.remove("is-scrolling-down");
        dirDelta = 0;
        return;
      }

      // Accumulate same-direction delta to ignore tiny jitter
      if (Math.sign(dy) !== Math.sign(dirDelta)) dirDelta = 0;
      dirDelta += dy;

      if (dirDelta > 8) {
        nav.classList.add("is-scrolling-down");
        dirDelta = 0;
      } else if (dirDelta < -8) {
        nav.classList.remove("is-scrolling-down");
        dirDelta = 0;
      }
    }

    // 1. IntersectionObserver — fires when hero exits the viewport
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function () {
        update();
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
      io.observe(hero);
    }

    // 2. Native scroll listener — fires during any scroll
    var raf = 0;
    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("scroll", onScroll, { passive: true });

    // 3. Lenis scroll event — fires inside Lenis's animation loop
    function attachLenis(tries) {
      tries = tries || 0;
      if (window.__benLenis && typeof window.__benLenis.on === "function") {
        window.__benLenis.on("scroll", update);
        return;
      }
      if (tries < 30) setTimeout(function () { attachLenis(tries + 1); }, 200);
    }
    attachLenis();

    // Initial state
    update();
  })();

  // ===================================================================
  // SCROLL-TO-TOP — visible after 600px scroll
  // ===================================================================
  (function () {
    var btn = document.querySelector("[data-scroll-top]");
    if (!btn) return;
    var raf = 0;
    function update() {
      raf = 0;
      btn.classList.toggle("is-visible", window.scrollY > 600);
    }
    window.addEventListener("scroll", function () {
      if (raf) return;
      raf = requestAnimationFrame(update);
    }, { passive: true });
    btn.addEventListener("click", function () {
      if (window.__benLenis) {
        window.__benLenis.scrollTo(0, { duration: 1.2 });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    });
    update();
  })();

  // ===================================================================
  // IMAGE FADE-IN — add .is-loaded class when image finishes loading
  // ===================================================================
  (function () {
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add("is-loaded");
      } else {
        img.addEventListener("load", function () { img.classList.add("is-loaded"); }, { once: true });
        img.addEventListener("error", function () { img.classList.add("is-loaded"); }, { once: true });
      }
    });
  })();

  // ===================================================================
  // util
  // ===================================================================
  function escapeHtml(s) {
    return String(s || "").replace(/[&<>"']/g, function (c) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
    });
  }

  // Smooth-scroll for in-page anchors (existing behaviour kept)
  document.addEventListener("click", function (e) {
    var link = e.target.closest('a[href^="#"]:not([href="#"])');
    if (!link) return;
    var id = link.getAttribute("href").slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  // Cart drawer trigger from nav (don't navigate to /cart, open drawer)
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-cart-trigger]");
    if (!t) return;
    e.preventDefault();
    setOpenDrawer("cart");
  });
})();
